import { authClient } from '@app/icare/client/auth'

export type AppSession = NonNullable<Awaited<ReturnType<typeof authClient.getSession>>>

export const signInWithMicrosoft = (callbackURL?: string) =>
  authClient.signIn.social({ provider: 'microsoft', callbackURL: callbackURL ?? '/' })

export const signOut = async () => {
  await authClient.signOut()
  if (typeof window !== 'undefined') {
    window.location.reload()
  }
}
